import React, { useState } from "react";
import { Observer } from "mobx-react";
import { toJS } from "mobx";
import { Spinner } from "@common";
import locale from "@bonliva-crm/locale";
import { ErrorBoundary } from "@common/error-boundary";
import { Button, Paper } from "@material-ui/core";
import { ContractsPriceTemplateType } from "@graphql";
import {
  ContractPriceTemplateRecordInput,
  ContractPriceTemplateFormInput
} from "@config_editor/ContractsPriceTemplates/ContractsPriceTemplateFormInput";
import AddToFavDialog from "@contracts/AddToFavDialog/AddToFavDialog";
import { ContractHolidays } from "@contracts/CustomerContractEditor/components/ContractHolidays/ContractHolidays";
import { ValidateCustomerContractOptionResult } from "@api/timereports";
import { PriceRecordFromAlt } from "./components/PriceRecordFormAlt";
import { FormStore } from "@modules/formx";

type Props<T> = {
  formStore: FormStore<T>;
  name: string;
  holidaysName?: string;
  loading?: boolean;
  addBlankRecord: () => void;
  duplicateRecord: (item: ContractPriceTemplateRecordInput) => void;
  variant?: "template" | "customerContract" | "consultantContract";
  type?: ContractsPriceTemplateType;
  validationResult?: ValidateCustomerContractOptionResult[];
  disabled?: boolean;
  hideHolidays?: boolean;
  isNationalProcurementPriceStrategy?: boolean;
  isNationalProcurement?: boolean;
  isBonlivaCare?: boolean;
};

export function ContractsPriceTemplateEditorForm<T>({
  formStore,
  duplicateRecord,
  loading,
  type,
  name = "records",
  holidaysName = "highHolidays",
  variant = "template",
  validationResult = [],
  disabled = false,
  hideHolidays = false,
  isNationalProcurement = false,
  isNationalProcurementPriceStrategy = false,
  isBonlivaCare = false
}: Props<T>) {
  const [show, setShow] = useState(false);

  const getTemplateInput = () => {
    const records = toJS(formStore.getValue(name));
    const holidays = toJS(formStore.getValue(holidaysName));
    const input: ContractPriceTemplateFormInput = new ContractPriceTemplateFormInput();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    input.records = records;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    input.highHolidays = holidays;
    input.type = type;
    input.private = true;
    return input;
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <ErrorBoundary>
      <div>
        <Observer>
          {() => {
            return (
              <Paper style={{ padding: "0 8px" }} aria-disabled={disabled}>
                <PriceRecordFromAlt
                  formStore={formStore}
                  type={type}
                  variant={variant}
                  // addRecordByType={duplicateRecord}
                  duplicateRecord={duplicateRecord}
                  name={name}
                  validationResult={validationResult}
                  disabled={disabled}
                  showArticleNumberForOtherSpeciality={isNationalProcurement}
                  isNationalProcurementPriceStrategy={isNationalProcurementPriceStrategy}
                  isBonlivaCare={isBonlivaCare}
                />
                {show && (
                  <AddToFavDialog
                    getInput={getTemplateInput}
                    open={show}
                    onClose={() => setShow(false)}
                  />
                )}
                {hideHolidays ? null : (
                  <Paper style={{ marginTop: 16 }} elevation={0}>
                    <ContractHolidays
                      formStore={formStore}
                      name={holidaysName}
                      disabled={disabled}
                    />
                  </Paper>
                )}

                {variant !== "template" && (
                  <div style={{ padding: 8, display: "flex" }}>
                    <Button
                      onClick={() => setShow(true)}
                      variant="text"
                      style={{ marginLeft: "auto" }}
                    >
                      {locale.AddToFav}
                    </Button>
                  </div>
                )}
              </Paper>
            );
          }}
        </Observer>
      </div>
    </ErrorBoundary>
  );
}
